import { useState, useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'
import api from '../services/api'
import { useListaFlutuante } from '../hooks/useListaFlutuante'

interface Conta {
  dep_cod: string
  dep_des: string
}

interface Props {
  value: string
  onChange: (cod: string, des: string) => void
}

export default function ContaSelect({ value, onChange }: Props) {
  const [aberta, setAberta] = useState(false)
  const [filtro, setFiltro] = useState('')
  const [contas, setContas] = useState<Conta[]>([])
  const [localCod, setLocalCod] = useState(value)
  const [aviso, setAviso] = useState('')
  const ref = useRef<HTMLDivElement>(null)
  const { posicao, listaRef } = useListaFlutuante(ref, aberta, () => setAberta(false))

  useEffect(() => { setLocalCod(value); if (value) setAviso('') }, [value])

  useEffect(() => {
    api.get('/erp/contas').then(r => setContas(r.data)).catch(() => setContas([]))
  }, [])

  const selecionada = contas.find(c => c.dep_cod === value)

  const lista = contas.filter(c => {
    if (!filtro) return true
    const f = filtro.toLowerCase()
    return c.dep_cod.toLowerCase().includes(f) || c.dep_des.toLowerCase().includes(f)
  })

  function selecionar(c: Conta) {
    onChange(c.dep_cod, c.dep_des)
    setLocalCod(c.dep_cod)
    setAviso('')
    setAberta(false)
    setFiltro('')
  }

  function handleCodBlur() {
    if (!localCod) { onChange('', ''); setAviso(''); return }
    const encontrada = contas.find(c => c.dep_cod === localCod)
    if (encontrada) {
      onChange(localCod, encontrada.dep_des)
      setAviso('')
      setAberta(false)
    } else {
      onChange('', '')
      setAviso(`Código "${localCod}" não encontrado`)
    }
  }

  return (
    <div className="nat-wrap" ref={ref}>
      <div className="nat-input-row">
        <input
          className="nat-cod-input"
          type="text"
          placeholder="Cód."
          value={localCod}
          style={aviso ? { borderColor: '#dc2626' } : undefined}
          onChange={e => { setLocalCod(e.target.value); setAviso('') }}
          onBlur={handleCodBlur}
          onKeyDown={e => { if (e.key === 'Enter') handleCodBlur() }}
        />
        <div className="nat-desc-box" onClick={() => setAberta(o => !o)}>
          {selecionada
            ? <span className="nat-dsc">{selecionada.dep_des}</span>
            : <span className="nat-placeholder">Selecione ou digite o código...</span>
          }
          <span className="nat-chevron">{aberta ? '▴' : '▾'}</span>
        </div>
      </div>
      {aviso && <div style={{ fontSize: '0.75rem', color: '#dc2626', marginTop: '0.2rem', paddingLeft: '0.25rem' }}>{aviso}</div>}

      {aberta && posicao && createPortal(
        <div ref={listaRef} className="nat-lista" style={{ position: 'fixed', ...posicao, minWidth: posicao.width }}>
          <div className="nat-filtro-wrap">
            <input
              autoFocus
              className="nat-filtro"
              placeholder="Buscar por código ou descrição..."
              value={filtro}
              onChange={e => setFiltro(e.target.value)}
            />
          </div>
          <div className="nat-itens">
            {lista.length === 0 && <div className="nat-vazio">Nenhum resultado</div>}
            {lista.map(c => (
              <button
                key={c.dep_cod}
                className={`nat-item${c.dep_cod === value ? ' nat-item--ativo' : ''}`}
                onClick={() => selecionar(c)}
              >
                <div className="nat-item-linha1">
                  <span className="nat-item-cod">#{c.dep_cod}</span>
                </div>
                <div className="nat-item-dsc">{c.dep_des}</div>
              </button>
            ))}
          </div>
        </div>,
        document.body
      )}
    </div>
  )
}
